import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid m-0 p-0" }
const _hoisted_2 = { class: "d-none d-lg-block" }
const _hoisted_3 = { class: "d-block d-lg-none" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col m-2" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Réinitialisation mot de passe")
  ])
], -1)
const _hoisted_5 = { class: "row mx-3 mx-lg-0 mt-md-3 mt-2 mx-3 mx-md-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-md col-lg" }, null, -1)
const _hoisted_7 = { class: "col col-md-6 col-lg-3 text-start" }
const _hoisted_8 = { class: "row fw-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col text-danger" }, " Les deux mots de passe ne correspondent pas! ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row mt-2 fw-bold" }
const _hoisted_12 = { class: "col form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "inputNewPassword" }, "Nouveau mot de passe: ", -1)
const _hoisted_14 = { class: "row my-2 fw-bold" }
const _hoisted_15 = { class: "col form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "inputConfirmPassword" }, "Confirmer mot de passe: ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col form-group text-center text-md-end" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-primary",
      type: "submit"
    }, " Réinitialiser mon mot de passe ")
  ])
], -1)
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-md col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordReseted = _resolveComponent("PasswordReseted")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_MiniTopBar = _resolveComponent("MiniTopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_PasswordReseted, { onClosePasswordResetedModal: _ctx.togglePasswordResetedModal }, null, 8, ["onClosePasswordResetedModal"]), [
      [_vShow, _ctx.showPasswordResetedModal]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TopBar, { userButton: false })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_MiniTopBar, { userButton: false })
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
          [_vShow, _ctx.wrongPassword]
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                id: "inputNewPassword",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                minlength: "8",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.newPassword]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                id: "inputConfirmPassword",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                minlength: "8",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.confirmPassword]
              ])
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col form-group text-center text-md-end error" }, _toDisplayString(_ctx.errorMsg), 513), [
              [_vShow, _ctx.error]
            ])
          ])
        ], 32)
      ]),
      _hoisted_19
    ])
  ]))
}